<template>
  <div class="total-box">
    <p class="title">
      {{ $t('CLOSING_REASONS.TABLE.TOTAL_RESOLVED_CONVERSATIONS') }}
    </p>
    <p class="number">{{ total }}</p>
  </div>
</template>

<script>
export default {
  name: 'ClosingReasonsTotal',
  props: {
    reasonsData: {
      type: Array,
      required: true,
    },
  },
  computed: {
    total() {
      return this.reasonsData.length;
    },
  },
};
</script>

<style scoped>
.total-box {
  background-color: #e2e8f0;
  padding: 16px;
  border-radius: 8px;
  width: 240px;
  text-align: center;
  margin-top: 80px;
}

.title {
  font-size: 14px;
  color: #4a5568;
  margin-bottom: 4px;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #2d3748;
}
</style>
